<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-copyright">
            <p class="mb-0">©  2021 Naci Karabulut - All Rights Reserved.</p>
        </div>
    </div>
</div>